import styled from '@emotion/styled';
import { rgba } from 'polished';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const RadioWrapper = styled.div(() =>
  mq({
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
  }),
);

export const StyledRadio = styled.input((props: { disabled?: boolean }) =>
  mq({
    position: 'relative',
    height: '20px',
    width: '20px',
    border: `1px solid ${defaultTheme.border.color.mediumGray}`,
    borderRadius: '50%',
    backgroundColor: props.disabled && defaultTheme.background.lightGray,
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    opacity: props.disabled && defaultTheme.button.opacity.hover,
    '&:checked': {
      border: `1px solid ${defaultTheme.border.color.primary}`,
      background: defaultTheme.background.primary,
      '&::before': {
        content: "''",
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '15px',
        height: '15px',
        border: `2px solid ${defaultTheme.background.white}`,
        borderRadius: '50%',
        backgroundColor: 'transparent',
      },
    },
    cursor: props.disabled ? 'not-allowed' : 'pointer',
  }),
);

export const RadioLabel = styled.label(
  (props: { disabled?: boolean; margin: keyof typeof defaultTheme.spacing }) =>
    mq({
      color: props.disabled
        ? rgba(defaultTheme.text.default, 0.3)
        : defaultTheme.text.default,
      cursor: `${props.disabled ? 'default' : 'pointer'} !important`,
      paddingLeft: defaultTheme.spacing[props.margin],
    }),
);
